"use client"

import Stages from "@/components/Stages/Stages"

export default function DashboardPage() {
  return <Stages />
}